// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9cbaaf3","455":"ae060335","977":"1c206e00"}[chunkId] + ".chunk.js";
};